import { ArrowUpRight } from "lucide-react";

const services = [
  {
    title: "Vályog házak",
    description: "A vályogházak természetes falai jó klímát teremtenek, így valóban egészséges és tartós otthonként állnak.",
    image: "/images/service1.jpg",
    size: "large",
  },
  {
    title: "Vegyes falazatú házak",
    description: "A vegyes falazatú házak több anyag előnyeit egyesítik, így tartós, stabil és értékes otthonok maradnak.",
    image: "/images/service2.jpg",
    size: "medium",
  },
  {
    title: "Vert falú házak",
    description: "A vert falú házak tömör falai jó klímát adnak, így tartós és értékes otthonként szolgálnak minden évben.",
    image: "/images/service3.jpg",
    size: "medium",
  },
];

const ServicesSection = () => {
  const scrollToSurvey = () => {
    const element = document.querySelector("#survey");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-20 md:py-32 bg-slate-50 geo-pattern"
    >
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            SZOLGÁLTATÁSAINK
          </div>
          <h2
            className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 mb-4"
            style={{ fontFamily: "'Manrope', sans-serif" }}
          >
            Miben tudunk segíteni?
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Munkánk során minden részletre kiterjedő figyelemmel dolgozunk: a talaj minőségétől kezdve a falak szerkezetén át egészen a belső klíma optimalizálásáig.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Large Card */}
          <div
            data-testid="service-card-0"
            className="bg-white p-8 md:p-10 rounded-3xl border border-blue-50 hover:border-blue-200 shadow-card hover:shadow-card-hover transition-all duration-300 group md:row-span-2"
          >
            <div className="h-64 md:h-80 rounded-2xl overflow-hidden mb-6">
              <img
                src={services[0].image}
                alt={services[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <h3
              className="text-2xl md:text-3xl font-bold text-slate-900 mb-4"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              {services[0].title}
            </h3>
            <p className="text-slate-600 leading-relaxed mb-6 text-lg">
              {services[0].description}
            </p>
            <button
              onClick={scrollToSurvey}
              className="inline-flex items-center gap-2 text-blue-900 font-bold hover:gap-3 transition-all group/btn"
            >
              Érdeklődöm
              <ArrowUpRight className="w-5 h-5 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform" />
            </button>
          </div>

          {/* Medium Cards */}
          {services.slice(1).map((service, index) => (
            <div
              key={service.title}
              data-testid={`service-card-${index + 1}`}
              className="bg-white p-8 rounded-3xl border border-blue-50 hover:border-blue-200 shadow-card hover:shadow-card-hover transition-all duration-300 group flex flex-col"
            >
              <div className="h-48 rounded-2xl overflow-hidden mb-6">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <h3
                className="text-xl md:text-2xl font-bold text-slate-900 mb-3"
                style={{ fontFamily: "'Manrope', sans-serif" }}
              >
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed mb-6 flex-1">
                {service.description}
              </p>
              <button
                onClick={scrollToSurvey}
                className="inline-flex items-center gap-2 text-blue-900 font-bold hover:gap-3 transition-all group/btn"
              >
                Érdeklődöm
                <ArrowUpRight className="w-5 h-5 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
